import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";
import { CreateRoleDto } from "./Dto/CreateRoleDto";
import { DeleteRoleDto } from "./Dto/DeleteRoleDto";
import { UpdateRoleDto } from "./Dto/UpdateRoleDto";
import { RoleEntity } from "./Entity/RoleEntity";

export const getRoleList = async (payload?: string): Promise<RoleEntity[]> => {
  try {
    const response = await HttpService.get(
      `${ApiService.roles.getRoles}/${payload || ""}`
    );
    return RoleEntity.fromJSON(response.data.data);
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to fetch role list");
  }
};

export const updateRole = async (payload: UpdateRoleDto): Promise<boolean> => {
  try {
    await HttpService.post(
      ApiService.roles.updateRole,
      JSON.stringify(UpdateRoleDto.toJSON(payload))
    );
    return true;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to update role list");
  }
};

export const createRole = async (payload: CreateRoleDto): Promise<boolean> => {
  try {
    await HttpService.post(
      ApiService.roles.createRole,
      JSON.stringify(CreateRoleDto.toJSON(payload))
    );
    return true;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to create role");
  }
};

export const deleteRole = async (payload: DeleteRoleDto): Promise<boolean> => {
  try {
    await HttpService.post(
      ApiService.roles.deleteRole,
      JSON.stringify(payload)
    );
    return true;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to delete role");
  }
};
